export enum RenderType {
  None,
  Transform,
  UpdateItems,
  UpdateRaycast,
  UpdateSelect,
  UpdateOver,
}
